export enum TopicStatus {
    NEW = 'NEW',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED'
}
